// @ts-nocheck
// fetch requested quote
export const FETCH_SUBMITTED_QUOTES_REQUEST = "FETCH_SUBMITTED_QUOTES_REQUEST";
export const FETCH_SUBMITTED_QUOTES_SUCCESS = "FETCH_SUBMITTED_QUOTES_SUCCESS";
export const FETCH_SUBMITTED_QUOTES_FAILURE = "FETCH_SUBMITTED_QUOTES_FAILURE";

// send message
export const SEND_MESSAGE_REQUEST = "SEND_MESSAGE_REQUEST";
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAILURE = "SEND_MESSAGE_FAILURE";